import React, { useState } from 'react';

const DocumentUploadAPIExecutor = () => {
    const [file, setFile] = useState(null);
    const [base64, setBase64] = useState('');
    const [selectedAPI, setSelectedAPI] = useState('');
    const [loading, setLoading] = useState(false);
    const [response, setResponse] = useState(null);
    const [error, setError] = useState('');
    const [preview, setPreview] = useState('');
    const [isCopied, setIsCopied] = useState(false);

    const queryParams = new URLSearchParams(window.location.search);
    const env = queryParams.get('env');

    const apiOptions = [
        { value: 'ValidateImage', label: 'Validate Image', endpoint: '/api/validate-Image' },
        { value: 'PO', label: 'PO Document', endpoint: '/api/ocr/pdf-base64-reader' },
        { value: 'PGPO', label: 'PG PO Document', endpoint: '/api/ocr/pdf-base64-reader' },
        { value: 'Lease', label: 'Lease Document', endpoint: '/api/ocr/pdf-base64-reader' },
        { value: 'Deed', label: 'Deed Document', endpoint: '/api/ocr/pdf-base64-reader' },
        { value: 'Bill', label: 'Bill Document', endpoint: '/api/ocr/pdf-base64-reader' },
        { value: 'Auth', label: 'Auth Document', endpoint: '/api/ocr/pdf-base64-reader' },
        { value: 'MCA', label: 'MCA Document', endpoint: '/api/ocr/pdf-base64-reader' },
        { value: 'MOA', label: 'MOA Document', endpoint: '/api/ocr/pdf-base64-reader' },
        { value: 'inst', label: 'installation Data', endpoint: '/api/installation/getdata' },
        { value: 'powerCheck', label: 'Power Check', endpoint: '/whatsapp/powercheck' },
        // { value: 'PAN', label: 'PAN Document', endpoint: '/api/ocr/pdf-base64-reader' },
        // { value: 'Aadhar', label: 'Aadhar Document', endpoint: '/api/ocr/pdf-base64-reader' },
        // { value: 'GST', label: 'GST Document', endpoint: '/api/ocr/pdf-base64-reader' },
        // { value: 'DITServ', label: 'DITServ Document', endpoint: '/api/ocr/pdf-base64-reader' },
        // { value: 'DevIT', label: 'DevIT Document', endpoint: '/api/ocr/pdf-base64-reader' }
    ];

    const apiOptionsUat = [
        { value: 'ValidateImage', label: 'Validate Image', endpoint: '/api/validate-Image' },
        { value: 'PO', label: 'PO Document', endpoint: '/api/ocr2/pdf-base64-reader' },
        { value: 'PGPO', label: 'PG PO Document', endpoint: '/api/ocr2/pdf-base64-reader' },
        { value: 'Lease', label: 'Lease Document', endpoint: '/api/ocr2/pdf-base64-reader' },
        { value: 'Deed', label: 'Deed Document', endpoint: '/api/ocr2/pdf-base64-reader' },
        { value: 'Bill', label: 'Bill Document', endpoint: '/api/ocr2/pdf-base64-reader' },
        { value: 'Auth', label: 'Auth Document', endpoint: '/api/ocr2/pdf-base64-reader' },
        { value: 'MCA', label: 'MCA Document', endpoint: '/api/ocr2/pdf-base64-reader' },
        { value: 'MOA', label: 'MOA Document', endpoint: '/api/ocr2/pdf-base64-reader' },
        { value: 'inst', label: 'installation Data', endpoint: '/api/installation/getdata' },
        { value: 'powerCheck', label: 'Power Check', endpoint: '/whatsapp/powercheck' },
        // { value: 'PAN', label: 'PAN Document', endpoint: '/api/ocr2/pdf-base64-reader' },
        // { value: 'Aadhar', label: 'Aadhar Document', endpoint: '/api/ocr2/pdf-base64-reader' },
        // { value: 'GST', label: 'GST Document', endpoint: '/api/ocr2/pdf-base64-reader' },
        // { value: 'DITServ', label: 'DITServ Document', endpoint: '/api/ocr2/pdf-base64-reader' },
        // { value: 'DevIT', label: 'DevIT Document', endpoint: '/api/ocr2/pdf-base64-reader' }
    ];


    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        console.log("selectedFile",selectedFile);
        
        if (!selectedFile) return;

        const validTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp', 'application/pdf'];
        if (!validTypes.includes(selectedFile.type)) {
            setError('Invalid file type');
            return;
        }

        if (selectedFile.size > 10 * 1024 * 1024) {
            setError('File too large (max 5MB)');
            return;
        }

        setFile(selectedFile);
        setError('');
        setResponse(null);

        if (selectedFile.type.startsWith('image/')) {
            const reader = new FileReader();
            reader.onloadend = () => setPreview(reader.result);
            reader.readAsDataURL(selectedFile);
        } else {
            setPreview('');
        }

        convertToBase64(selectedFile);
    };

    const convertToBase64 = (file) => {
        const reader = new FileReader();
        reader.onloadend = () => {
            const base64String = reader.result.split(',')[1];
            setBase64(base64String);
        };
        reader.onerror = () => setError('Error reading file');
        reader.readAsDataURL(file);
    };

    const handleExecuteAPI = async () => {
        // For installation Data API, file is optional
        if (selectedAPI !== 'inst' && !file) {
            setError('Select a file first');
            return;
        }
        if (!selectedAPI) {
            setError('Select an API');
            return;
        }

        setLoading(true);
        setError('');
        setResponse(null);
        setIsCopied(false);

        try {
            const apiConfig = env == 'uat' ? apiOptionsUat.find(api => api.value === selectedAPI) : apiOptions.find(api => api.value === selectedAPI);
            if (!apiConfig) throw new Error('Invalid API selected');

            // Make API call
            let url = "https://oneml.spectra.co";
            if (env === 'uat') {
                url = "https://onemluat.spectra.co"
            }

            let response;

            // Handle installation Data API (GET request)
            if (apiConfig.value === 'inst') {
                response = await fetch(url + apiConfig.endpoint, {
                    method: 'GET',
                    headers: { 'Content-Type': 'application/json' }
                });
            } else {
                // Convert file to Base64
                const toBase64 = (file) => {
                    return new Promise((resolve, reject) => {
                        const reader = new FileReader();
                        reader.readAsDataURL(file);
                        reader.onload = () => resolve(reader.result.split(',')[1]); // remove "data:...base64,"
                        reader.onerror = (error) => reject(error);
                    });
                };

                const base64Data = await toBase64(file);

                let payload;
                if (apiConfig.value === 'ValidateImage') {
                    payload = {
                        oppID: "O-03-2025-148879",
                        cafID: "CAF_117089",
                        latitude: 28.4629171,
                        longitude: 77.0772455,
                        emp_code: "1234",
                        image_base64: base64Data
                    };
                } else if (apiConfig.value === 'powerCheck') {
                    payload = {
                        "source": "file_upload",
                        image: base64Data
                    };
                } else {
                    payload = {
                        ptype: apiConfig.value,
                        pdf_base64: base64Data
                    };
                }

                // console.log('Payload:', payload);

                response = await fetch(url + apiConfig.endpoint, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(payload),
                });
            }

            const result = await response.json();
            setResponse(result);

            if (apiConfig?.value === 'ValidateImage' && result?.data?.result?.code === 200 && result?.data?.result?.data?.watermarked_image) {
                setPreview(`data:image/png;base64,${result?.data?.result?.data?.watermarked_image}`);
                setBase64(result?.data?.result?.data?.watermarked_image);
            }
        } catch (err) {
            setError(err.message || 'API execution failed');
        } finally {
            setLoading(false);
        }
    };


    const handleReset = () => {
        setFile(null);
        setBase64('');
        setSelectedAPI('');
        setResponse(null);
        setError('');
        setPreview('');
    };

    return (
        <>
            <link
                href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css"
                rel="stylesheet"
            />

            <style>{`
        body, html, #root { height: 100%; margin: 0; overflow: hidden; }
        .full-height { height: 100vh; overflow: hidden; display: flex; flex-direction: column; }
        .scroll-section { 
          flex: 1; 
          overflow-y: auto !important; 
          overflow-x: hidden; 
          max-height: 100vh; 
        }
        .compact-input { padding: 0.4rem 0.75rem; font-size: 0.875rem; }
        .compact-btn { padding: 0.4rem 1rem; font-size: 0.875rem; }
        .compact-label { font-size: 0.813rem; margin-bottom: 0.25rem; font-weight: 600; }
        .preview-img { max-height: 180px; object-fit: contain; }
        pre { font-size: 0.75rem; max-height: 400px; overflow-y: auto; }

        /* Enable overall scroll for body */
        html, body {
            height: auto;
            overflow: visible;
        }

        /* Custom Scrollbar Styling */
        .scroll-section::-webkit-scrollbar,
        pre::-webkit-scrollbar {
          width: 8px;
          height: 8px;
        }

        .scroll-section::-webkit-scrollbar-track,
        pre::-webkit-scrollbar-track {
          background: #f1f1f1;
          border-radius: 10px;
        }

        .scroll-section::-webkit-scrollbar-thumb,
        pre::-webkit-scrollbar-thumb {
          background: #888;
          border-radius: 10px;
        }

        .scroll-section::-webkit-scrollbar-thumb:hover,
        pre::-webkit-scrollbar-thumb:hover {
          background: #555;
        }

        /* Firefox Scrollbar */
        .scroll-section,
        pre {
          scrollbar-width: thin;
          scrollbar-color: #888 #f1f1f1;
        }
      `}</style>

            <div className="container-fluid full-height p-0">
                <div className="row g-0 h-100">

                    {/* Left Panel - Upload & Controls */}
                    <div className="col-md-6 bg-light border-end">
                        <div className="scroll-section p-3">

                            <div className="text-center mb-0">
                                {/* <h4 className="fw-bold text-primary mb-1">Document API Executor</h4> */}
                                <small className="text-muted">Upload & Execute APIs</small>
                            </div>

                            {/* API Selection */}
                            <div className="mb-0">
                                <label className="form-label compact-label">Select API</label>
                                <select
                                    value={selectedAPI}
                                    onChange={(e) => setSelectedAPI(e.target.value)}
                                    className="form-select compact-input"
                                >
                                    <option value="">Choose API...</option>
                                    {(env === 'uat' ? apiOptionsUat : apiOptions).map((api) => (
                                        <option key={api.value} value={api.value}>{api.label}</option>
                                    ))}
                                </select>
                            </div>

                            {/* Upload */}
                            <div className="mb-0">
                                <label className="form-label compact-label">Upload Document</label>
                                <input
                                    type="file"
                                    onChange={handleFileChange}
                                    accept="image/*,.pdf"
                                    className="form-control compact-input"
                                />
                                <small className="text-muted">PNG, JPG, PDF (max 5MB)</small>
                            </div>

                            {/* Preview */}
                            {preview && (
                                <div className="mb-3">
                                    <label className="form-label compact-label">Preview</label>
                                    <div className="border rounded p-2 bg-white text-center">
                                        <img src={preview} alt="Preview" className="img-fluid preview-img rounded" />
                                    </div>
                                </div>
                            )}

                            {/* File Info */}
                            {file && (
                                <div className="alert alert-info py-2 px-3 mb-3">
                                    <div className="d-flex align-items-center">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-file-earmark me-2 flex-shrink-0" viewBox="0 0 16 16">
                                            <path d="M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5zm-3 0A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5z" />
                                        </svg>
                                        <div className="small">
                                            <strong>{file.name}</strong><br />
                                            <span className="text-muted">{file.type} • {(file.size / 1024).toFixed(2)} KB</span>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* Buttons */}
                            <div className="d-flex gap-2 mb-3">
                                <button
                                    onClick={handleExecuteAPI}
                                    disabled={(selectedAPI !== 'inst' && !file) || !selectedAPI || loading}
                                    className="btn btn-primary compact-btn flex-grow-1"
                                >
                                    {loading ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm me-1"></span>
                                            Processing...
                                        </>
                                    ) : (
                                        <>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" className="bi bi-send me-1" viewBox="0 0 16 16">
                                                <path d="M15.854.146a.5.5 0 0 1 .11.54l-5.819 14.547a.75.75 0 0 1-1.329.124l-3.178-4.995L.643 7.184a.75.75 0 0 1 .124-1.33L15.314.037a.5.5 0 0 1 .54.11ZM6.636 10.07l2.761 4.338L14.13 2.576zm6.787-8.201L1.591 6.602l4.339 2.76z" />
                                            </svg>
                                            Execute
                                        </>
                                    )}
                                </button>
                                <button onClick={handleReset} className="btn btn-secondary compact-btn">
                                    Reset
                                </button>
                            </div>

                            {/* Error */}
                            {error && (
                                <div className="alert alert-danger py-2 px-3 mb-3">
                                    <small>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-exclamation-circle me-1" viewBox="0 0 16 16">
                                            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                                            <path d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0M7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0z" />
                                        </svg>
                                        <strong>Error:</strong> {error}
                                    </small>
                                </div>
                            )}

                            {/* Base64 Info */}
                            {base64 && (
                                <div className="card position-relative">
                                    <div className="card-header py-2 px-3 bg-secondary text-white d-flex justify-content-between align-items-center">
                                        <small className="fw-semibold">Base64 Info</small>
                                        <button
                                            className="btn btn-sm btn-light text-dark px-2 py-1"
                                            onClick={() => {
                                                navigator.clipboard.writeText(base64);
                                                setIsCopied(true);
                                            }}
                                            title="Copy Base64"
                                        >
                                            {isCopied ? "Copied" : "Copy"}
                                        </button>
                                    </div>
                                    <div className="card-body py-2 px-3">
                                        <small className="text-muted">
                                            Length: {base64.length} characters<br />
                                            <span className="font-monospace text-break">
                                                {base64.substring(0, 78)}...
                                            </span>
                                        </small>
                                    </div>
                                </div>
                            )}


                        </div>
                    </div>

                    {/* Right Panel - Response */}
                    <div className="col-md-6 bg-white">
                        <div className="scroll-section p-3">

                            <div className="mb-3">
                                <h5 className="fw-bold mb-1">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-receipt me-2" viewBox="0 0 16 16">
                                        <path d="M1.92.506a.5.5 0 0 1 .434.14L3 1.293l.646-.647a.5.5 0 0 1 .708 0L5 1.293l.646-.647a.5.5 0 0 1 .708 0L7 1.293l.646-.647a.5.5 0 0 1 .708 0L9 1.293l.646-.647a.5.5 0 0 1 .708 0l.646.647.646-.647a.5.5 0 0 1 .708 0l.646.647.646-.647a.5.5 0 0 1 .801.13l.5 1A.5.5 0 0 1 15 2v12a.5.5 0 0 1-.053.224l-.5 1a.5.5 0 0 1-.8.13L13 14.707l-.646.647a.5.5 0 0 1-.708 0L11 14.707l-.646.647a.5.5 0 0 1-.708 0L9 14.707l-.646.647a.5.5 0 0 1-.708 0L7 14.707l-.646.647a.5.5 0 0 1-.708 0L5 14.707l-.646.647a.5.5 0 0 1-.708 0L3 14.707l-.646.647a.5.5 0 0 1-.801-.13l-.5-1A.5.5 0 0 1 1 14V2a.5.5 0 0 1 .053-.224l.5-1a.5.5 0 0 1 .367-.27m.217 1.338L2 2.118v11.764l.137.274.51-.51a.5.5 0 0 1 .707 0l.646.647.646-.646a.5.5 0 0 1 .708 0l.646.646.646-.646a.5.5 0 0 1 .708 0l.646.646.646-.646a.5.5 0 0 1 .708 0l.646.646.646-.646a.5.5 0 0 1 .708 0l.509.509.137-.274V2.118l-.137-.274-.51.51a.5.5 0 0 1-.707 0L12 1.707l-.646.647a.5.5 0 0 1-.708 0L10 1.707l-.646.647a.5.5 0 0 1-.708 0L8 1.707l-.646.647a.5.5 0 0 1-.708 0L6 1.707l-.646.647a.5.5 0 0 1-.708 0L4 1.707l-.646.647a.5.5 0 0 1-.708 0z" />
                                    </svg>
                                    API Response
                                </h5>
                                <small className="text-muted">Response will appear here</small>
                            </div>

                            {!response && !loading && (
                                <div className="text-center py-5 text-muted">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" fill="currentColor" className="bi bi-inbox mb-3" viewBox="0 0 16 16">
                                        <path d="M4.98 4a.5.5 0 0 0-.39.188L1.54 8H6a.5.5 0 0 1 .5.5 1.5 1.5 0 1 0 3 0A.5.5 0 0 1 10 8h4.46l-3.05-3.812A.5.5 0 0 0 11.02 4zm-1.17-.437A1.5 1.5 0 0 1 4.98 3h6.04a1.5 1.5 0 0 1 1.17.563l3.7 4.625a.5.5 0 0 1 .106.374l-.39 3.124A1.5 1.5 0 0 1 14.117 13H1.883a1.5 1.5 0 0 1-1.489-1.314l-.39-3.124a.5.5 0 0 1 .106-.374z" />
                                    </svg>
                                    <p>No response yet. Execute an API to see results.</p>
                                </div>
                            )}

                            {response && (
                                <div className="alert alert-success mb-3 py-2 px-3">
                                    <div className="d-flex align-items-center">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-check-circle-fill me-2 flex-shrink-0" viewBox="0 0 16 16">
                                            <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M6.97 11.03l-3.992-3.992a.75.75 0 1 1 1.06-1.06L7 9.439l5.962-5.962a.75.75 0 1 1 1.06 1.06z" />
                                        </svg>
                                        <div>
                                            <strong>API Executed:</strong> {response.api}
                                        </div>
                                    </div>
                                </div>
                            )}

                            {response && (
                                <pre className="bg-light border rounded p-3">
                                    {JSON.stringify(response, null, 2)}
                                </pre>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default DocumentUploadAPIExecutor;
